<template>
    <base-modal v-bind:modalTitle="'Edit Tags Rule'" v-on:save="save()" v-on:close="close()">
        <FormulateForm>
            <FormulateInput type="text" v-model="model.name" label="Name" validation="required" />
        </FormulateForm>
        <h4>Rule</h4>
        <FormulateInput type="checkbox" v-model="model.negated" label="Negated" />

        <div class="rule-wrapper">
            <div class="rule" :class="{operator: r.type == 'operator', tag: r.type == 'tag'}" v-for="(r, ix) in model.terms">
                <div v-if="r.type == 'tag'" class="header text-right"><button @click="removeTerm(ix)"><i class="fa fa-close"></i></button></div>
                <div class="body">
                    <FormulateInput v-if="r.type == 'tag'" type="select" :options="tagOptions" v-model="r.value" placeholder="Select tag" />
                    <FormulateInput v-if="r.type == 'operator'" type="select" :options="{'AND': 'AND', 'OR': 'OR'}" v-model="r.value" />
                </div>
            </div>

            <div class="rule plus">
                <div class="body">
                    <FormulateInput type="button" @click="addNextTerm"><i class="fa fa-plus"></i></FormulateInput>
                </div>
            </div>

        </div>
    </base-modal>
</template>

<script>
 // Load the full build.
 var _ = require('lodash');

 import BaseModal from 'components/modals/BaseModal';

 export default {
    components: {
      BaseModal
    },
    props: {
      tags: Array,
      rule: {
        type: Object,
        default () {
          return {
            id: null,
            name: '',
            negated: false,
            terms: []
          };
        }
      },
    },

    data () {
      return {
        fields: {},
        model: {
          id: null,
          name: '',
          negated: false,
          terms: []
        },
        tagsDb: {}
      };
    },

    created () {
      this.tagsDb = Object.fromEntries(this.tags.map( t => [t.id, t] ));
      if (this.rule) {
        this.model = _.clone(this.rule, true);
      }
     },
    computed: {
      tagOptions: function () {
        return Object.values(this.tagsDb).map(t =>  {
          return { value: t.id, label: t.name };
        });
      }
     },
    methods: {
      removeTerm(ix) {
        if (ix == 0) {
          this.model.terms.splice(ix, 2);
        }
        else {
          let item = this.model.terms[ix];

          if (item.type == 'operator') {
            this.model.terms.splice(ix, 2);
          }
          else {
            this.model.terms.splice(ix-1, 2);
          }
        }
      },
      addNextTerm() {
        if (this.model.terms.length > 0) {
          this.model.terms.push({type: 'operator', value: 'AND'});
        }
        this.model.terms.push({type: 'tag', value: null});
      },
      async fetchTags() {
        const res =  await API.tags.getList();
        this.tagsDb = Object.fromEntries( res.data.results.map( t => [t.id, t]) );
      },
      close() {
        this.$emit('close');
      },
      save() {
        var requestData = {};

        // ID
        if (this.model.id) {
          requestData.id = this.model.id;
        }
        // Name
        if (this.model.name) {
          requestData.name = this.model.name;
        }
        if (this.model.terms) {
          requestData.terms = this.model.terms;
        }

        requestData.negated = this.model.negated;

        if (requestData) {
          var self = this;
          API.tags.saveRule(requestData)
             .then(function (response) {
               // closing modal
               self.$emit('close', true);
             });
        }
      }
    }

 }
</script>


<style lang="scss" scoped>
 .rule-wrapper {
     width: 100%;
     display: flex;
     flex-wrap: wrap;
     gap: .5rem;
     boder: 1px solid #666;
     background-color: #f3f3f3;
     border-radius: 4px 4px 4px 4px;
     padding: 1rem;

     .rule {
         display: flex;
         flex-direction: column;
         border: 1px solid #e5e5e5;
         border-radius: 4px 4px 4px 4px;
         background: #fff;
         justify-content: flex-end;

         &.tag {
             border-color: #98d598;
             background: #f6ffec;
         }

         &.plus {
             border: none;
             background: transparent;
         }

         .header {
             margin: 0;

             button {
                 border: none;
                 background: none;
             }
         }

         .body {
             padding: .5rem;
         }
     }

 }
</style>



// WEBPACK FOOTER //
// TagRuleModal.vue?1ecc9553